// @ts-check
const mapIdentifier = require('./identifier');
const mapInventoryProperties = require('./inventoryProperties');
const mapVariantProperties = require('./variantProperties');

/**
 * @param {import('../').EquinoxProductVariant} variant
 */
function mapVariant(variant) {
  /** @type {import('../').EquinoxProductVariant} */
  const model = {
    identifier: mapIdentifier(variant.identifier),
    inventory: '',
    properties: mapVariantProperties(variant.properties),
    promotion: [],
    priceFacets: {
      CV: '',
      PV: '',
      SB: '',
      'Wholesale Price': '',
      'Regular Price': ''
    },
    inventoryProperties: mapInventoryProperties(variant.inventoryProperties),
    totalValue: {
      originalPrice: 0,
      priceAfterDiscount: 0,
      priceFacets: {
        CV: {
          CV: 36
        },
        'Regular Price': {
          'Regular Price': 52
        },
        PV: {
          PV: 25.65
        },
        'Wholesale Price': {
          'Wholesale Price': 42
        },
        SB: {
          SB: 2
        }
      },
      totaldiscount: 0
    }
  };

  return model;
}

module.exports = mapVariant;
